export const comments_5618858 = {"data":{"data":[],"links":{}}}